import { createFileRoute, redirect, useNavigate, useRouter } from '@tanstack/react-router';
import { useContent } from '@altify/utils';
import BackButton from 'components/BackButton/BackButton';
import { Button, Heading, Markdown } from '@altify/components';
import CheckDottedIcon from 'assets/icons/check_dotted_outline_white.svg';
import { content } from '../route.content';

export const Route = createFileRoute(
  '/_authenticated/verification/submitted',
)({
  component: Submitted,
});

function Submitted() {
  const navigate = useNavigate();
  const router = useRouter();
  const localizedContent = useContent(content);

  return (
    <div className="static lg:relative w-full px-4 pt-4 h-full justify-between">
      <BackButton 
        className={'w-full text-left lg:bg-body-background mt-1 ml-0 pl-6 lg:-mt-4 pt-2 lg:ml-0 lg:pl-0 lg:pt-2'}
        onClick={() => router.history.back()}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-full">
        <div className="max-w-3xl mx-auto h-full">
          <div className="flex flex-col flex-grow justify-between lg:px-8 sm:px-6 py-6 lg:py-12 h-full pb-12">
            
              <div className="mb-8 justify-center flex flex-col items-center gap-6">
                <img src={CheckDottedIcon} alt="Exclamation Icon" className="w-24" />

                <div className="mx-10 md:mx-20 text-center justify-start">
                  <Heading level={3} className="mb-8">
                    {localizedContent.verifcationSubmittedHeading}
                  </Heading>
                  <Markdown
                    styles={{
                      text: {
                        textAlign: 'center',
                        color: '#ffffff',
                        display: 'flex',
                        fontFamily: 'Bozon',
                        justifyContent: 'center',
                        lineHeight: 25,
                        fontWeight: 300,
                      },
                      paragraph: {
                        color: '#ffffff',
                        justifyContent: 'center',
                        fontFamily: 'Bozon',
                        lineHeight: 25,
                        fontWeight: 300
                      }
                    }}>
                    {localizedContent.verifcationSubmittedBlurb}
                  </Markdown>
                </div>
              </div>
              <div className="justify-end text-center mx-5 md:mx-20">
                <div className="text-center mt-4 flex flex-col gap-2 mb-4">
                  <Button
                    text={localizedContent.exploreInvestments}
                    size="large"
                    onPress={() => {
                      navigate({ to: '/products' });
                    }}
                  />
                </div>
              </div>
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default Submitted;
